import React from "react";
import Icon from "../components/Icon";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { sharedStyles, SectionHead } from "./_shared";

const styles = `
.t26-contact__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: clamp(14px, 2vw, 20px);
}
.t26-contact__tile {
  display: flex; flex-direction: column; gap: 12px;
  padding: clamp(20px, 3vw, 28px);
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
  text-decoration: none;
  color: inherit;
}
.t26-contact__tile:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
  border-color: color-mix(in oklab, var(--primary) 35%, var(--line));
}
.t26-contact__icon {
  width: 48px; height: 48px;
  border-radius: var(--r-md);
  background: color-mix(in oklab, var(--primary) 12%, var(--surface));
  color: var(--primary);
  display: inline-flex; align-items: center; justify-content: center;
}
.t26-contact__label {
  font-size: 11px; font-weight: 700;
  letter-spacing: .18em; text-transform: uppercase;
  color: var(--ink-3);
}
.t26-contact__value {
  font-family: var(--font-display);
  font-size: 17px; font-weight: 700;
  color: var(--ink);
  word-break: break-word;
}
`;

export default function ContactBlock({ context, eyebrow, title, subtitle }) {
    const { org, config } = context;
    const tiles = [];

    if (org.contact?.tel) {
        tiles.push({
            href: `tel:${org.contact.tel}`,
            icon: "phone",
            label: t`Téléphone`,
            value: org.contact.tel,
        });
    }
    if (org.contact?.email) {
        tiles.push({
            href: `mailto:${org.contact.email}`,
            icon: "mail",
            label: t`Email`,
            value: org.contact.email,
        });
    }
    if (config["social.whatsapp"]) {
        tiles.push({
            href: config["social.whatsapp"],
            icon: "whatsapp",
            label: t`WhatsApp`,
            value: t`Discuter`,
            external: true,
        });
    }
    if (org.adresse) {
        tiles.push({
            href: null,
            icon: "mapPin",
            label: t`Adresse`,
            value: `${org.adresse}${org.ville ? `, ${org.ville}` : ""}`,
        });
    }

    if (tiles.length === 0) return null;

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: sharedStyles + styles }} />
            <section className="t26-section">
                <SectionHead
                    eyebrow={eyebrow || t`Nous contacter`}
                    title={title || t`Restons en lien`}
                    subtitle={subtitle || t`Toujours disponibles pour vous accueillir et répondre à vos questions`}
                />

                <div className="t26-contact__grid">
                    {tiles.map((tile, i) => {
                        const inner = (
                            <>
                                <span className="t26-contact__icon">
                                    <Icon name={tile.icon} size={20} />
                                </span>
                                <span className="t26-contact__label">{tile.label}</span>
                                <span className="t26-contact__value">{tile.value}</span>
                            </>
                        );
                        if (tile.href && tile.external) {
                            return <a key={i} href={tile.href} target="_blank" rel="noopener noreferrer" className="t26-contact__tile">{inner}</a>;
                        }
                        if (tile.href) {
                            return <a key={i} href={tile.href} className="t26-contact__tile">{inner}</a>;
                        }
                        return <div key={i} className="t26-contact__tile">{inner}</div>;
                    })}
                </div>
            </section>
        </>
    );
}
